import { observable } from 'mobx';
import { createContext } from 'react';

const GlobalStore = observable({
  emailSent: false,
  assetsImg: false,
  passivesImg: false,
  savingImg: false,
  patrimonyImg: false
});

GlobalStore.setValue = function(name, value) {
  this[name] = value;
};

const GlobalStoreContext = createContext(GlobalStore);

export default GlobalStoreContext;
